// removed by extract-text-webpack-plugin
module.exports = {"creditCardIcon":"payment-methods__creditCardIcon__3qOY4"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/payment-methods.scss
// module id = 1725
// module chunks = 4 14